var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Page',{staticClass:"top-margin"},[_c('Masthead',{attrs:{"title":"Explore Categories"}}),_c('ContentRow',[_c('ContentContainer',[_c('GridNav',{attrs:{"across":3}},_vm._l((_vm.categories),function(category){return _c('GridNavItem',{key:category.CategoryId,attrs:{"category":category}})}),1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }